import React from 'react'
import { IconButton } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const ArrowButton = ({ onClick, direction, sx, children }) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        ...sx,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      {children}
      <KeyboardArrowDownIcon
        sx={{
          transition: 'transform 0.3s',
          transform: direction === 'down' ? 'rotate(0deg)' : 'rotate(-90deg)',
          ml: children ? 0.5 : 0
        }}
      />
    </IconButton>
  )
}

export default ArrowButton
